module.exports = __webpack_public_path__ + "img/logoClara.af17253c.png";